import {PlayersStatisticsTableRowValueDomainModel} from "./players-statistics.table.row.value.domain-model";
import {BaseViewModel} from "../../../../../../../infrastructure/models/base-view-model";
import {PlayerStatisticsTableRowValueRequestParams} from "./player-statistics.table.row.value.request-params";

export class PlayersStatisticsTableRowValueViewModel extends BaseViewModel {
  domainModel: PlayersStatisticsTableRowValueDomainModel;
  shortName: String;
  isGraphicColumn: Boolean;

  constructor(domainModel: PlayersStatisticsTableRowValueDomainModel, shortName: String, isGraphicColumn: Boolean, groupColumnNumber: Number) {
    super(domainModel);

    this.shortName = shortName;
    this.isGraphicColumn = isGraphicColumn;
    this.groupColumnNumber = groupColumnNumber;
  }

  get columnNum(): Number {
    return this.domainModel.columnNum;
  }

  get value(): Number {
    return this.domainModel.value;
  }

  get shouldRenderIcon(): Boolean {
     return this.isGraphicColumn;
  }

  get logoRequestParam(): Boolean {
    return new PlayerStatisticsTableRowValueRequestParams(this.value);
  }
}
